/**
 * isiZulu: Channels
 *
 * What this file covers: Website chat, SMS, email, USSD and the other channels clients reach the business on.
 *
 * Tone: Clear and practical. Say what the client sees on each channel.
 *
 * isiZulu: Everyday isiZulu as used in South African business. Keys not translated yet fall back to English, so
 * a missing key is never an error.
 *
 * Rules for every translation: keep each key exactly as it is and translate only the text after it. Keep
 * {{placeholders}} such as {{count}} or {{name}} unchanged, and keep product names (RepletoryReach, WhatsApp,
 * Meta, Google, Outlook) as they are. Never use the em dash.
 */

import type { Catalog } from '../types';

const channels: Catalog = {
  'channels.title': 'Iziteshi',
  'channels.description': 'Izindawo amakhasimende angakubhalela kuzo, nokuxhunywe kuleso naleso.',
  'channels.connect': 'Xhuma ikhasi',
  'channels.connected': '{{name}} isixhunyiwe.',
  'channels.disconnected': 'Kunqanyuliwe.',
  'channels.check': 'Hlola',
  'channels.check.ok': 'Konke lesi siteshi esikudingayo sekukhona.',
  'channels.check.problems': 'Kukhona okudinga ukunakwa kulesi siteshi.',
  'channels.switchedOff': 'Kuvaliwe',
  'channels.receiving': 'Ithola imilayezo kusukela ngo-{{since}}',
  'channels.notReceiving': 'Ayikatholi milayezo. Xhuma leli khasi futhi ukuze uvule ukulethwa.',
  'channels.lastCheck.ok': 'Kuhlolwe okokugcina ngo-{{when}}: konke kuhamba kahle.',
  'channels.lastCheck.failed': 'Kuhlolwe okokugcina ngo-{{when}}: kukhona okudinga ukunakwa.',
  'channels.disconnect': 'Nqamula',
  'channels.disconnect.title': 'Unqamula lesi siteshi?',
  'channels.disconnect.body': 'Imilayezo emisha eya ku-{{name}} izoyeka ukufika. Izingxoxo zakho ezikhona zizohlala njengoba zinjalo, futhi ungaxhuma futhi noma nini.',
  'channels.disconnect.confirm': 'Nqamula',
  'channels.empty.title': 'Awukho ama-akhawunti e-Facebook noma e-Instagram okwamanje',
  'channels.empty.body': 'Xhuma ikhasi le-Facebook bese ibhothi yakho iphendula ku-Messenger, naku-Instagram ngokusebenzisa i-akhawunti exhunywe kulelo khasi.',
  'channels.elsewhere.title': 'Ezinye iziteshi zakho',
  'channels.elsewhere.whatsapp': 'Izinombolo ze-WhatsApp zixhunywa ku-',
  'channels.elsewhere.website': 'Ingxoxo yewebhusayithi ilungiselelwa ku-',
  'channels.connect.intro': 'Ngena ku-Facebook bese ukhetha ikhasi ofuna amakhasimende akubhalele kulo. Sicela kuphela lokho okudingekayo ukufunda lelo khasi nokuphendula imilayezo yalo.',
  'channels.connect.needs': 'Kufanele ube ngumlawuli wekhasi. Kwi-Instagram, i-akhawunti kufanele ibe ngeyobuchwepheshe futhi ixhunywe kulelo khasi.',
  'channels.connect.signIn': 'Qhubeka nge-Facebook',
  'channels.connectMessenger': 'Xhuma i-Messenger',
  'channels.connectInstagram': 'Xhuma i-Instagram',
  'channels.alreadyConnected': 'Kuxhunyiwe',
  'channels.instagram': 'Instagram',
  'channels.instagram.ready': 'I-akhawunti yobuchwepheshe ixhunywe kuleli khasi futhi ingaxhunywa.',
  'channels.instagram.personal': 'I-akhawunti ye-Instagram kuleli khasi ingeyomuntu siqu. Iguqule ibe ngeyobuchwepheshe ku-app ye-Instagram bese ubuya.',
  'channels.instagram.none': 'Ayikho i-akhawunti ye-Instagram exhunywe kuleli khasi okwamanje.',
  'channels.cannotMessage': 'Awukwazi ukuthumela imilayezo kusuka kuleli khasi. Cela lowo oliphethe akunike indima yemilayezo.',
  'channels.cannotSubscribe': 'Awukwazi ukuvula ukulethwa kwemilayezo kuleli khasi. Cela lowo oliphethe akwenze umlawuli.',
  'channels.noPages.title': 'Awekho amakhasi kule akhawunti',
  'channels.noPages.body': 'Le akhawunti ye-Facebook ayilawuli makhasi. Ngena ngesinye esinawo.',
  'channels.unavailable.title': 'Akukavulwa okwamanje',
  'channels.unavailable.body': 'Ukuxhuma ikhasi le-Facebook akukavulwa okwamanje. Sesaziswile, futhi ezinye iziteshi zakho ziyaqhubeka njengenjwayelo.',
  'channels.sdk.title': 'I-Facebook ayifinyelelekanga',
  'channels.sdk.blocked': 'Ukungena kwe-Facebook akukwazanga ukulayisha. Kuvame ukubangelwa isivimbeli sokuqukethwe noma isilungiselelo esiqinile sobumfihlo; zama futhi kuwindi elijwayelekile.',
  'channels.sdk.unavailable': 'Ukungena kwe-Facebook akukwazanga ukulayisha. Hlola uxhumano lwakho bese uzama futhi.',
  'channels.sdk.noToken': 'I-Facebook ayikuqedanga ukungena. Akukho okuxhunyiwe; zama futhi.'
};

export default channels;
